export const AppIcon = ({ app, containerClass = "", iconSize = 20, variant = "solid" }) => {
  if (app.iconImage) {
    return (
      <img
        src={app.iconImage}
        alt={app.name}
        className={`${containerClass} object-cover`}
        loading="lazy"
      />
    );
  }
  const Icon = app.icon;
  const style =
    variant === "solid"
      ? { backgroundColor: app.accent, color: "#fff" }
      : variant === "tint"
      ? { backgroundColor: `${app.accent}18`, color: app.accent }
      : { backgroundColor: `${app.accent}26`, color: app.accent };
  return (
    <span className={`${containerClass} flex items-center justify-center`} style={style}>
      <Icon size={iconSize} />
    </span>
  );
};

export default AppIcon;
